import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-impact-assessment-details',
  templateUrl: './impact-assessment-details.component.html',
  styleUrls: ['./impact-assessment-details.component.scss']
})
export class ImpactAssessmentDetailsComponent implements OnInit {

  impactAssessmentId: number;
  filterType: string;
  templateNo:number;
  idList: number[]=[];
  constructor(private route: ActivatedRoute) {
    
    // tslint:disable-next-line:no-string-literal
    this.impactAssessmentId = Number(this.route.snapshot.params['id']);
    // tslint:disable-next-line:no-string-literal
    this.filterType = this.route.snapshot.params['filter'];
    this.templateNo =  Number(this.route.snapshot.params['templateNo']);
    this.route.paramMap.subscribe(params => {
      const state = window.history.state;
      if (state && state.idList) {
        this.idList = state.idList;
      } else {
        this.idList = [];
      }
    });
  }

  ngOnInit(): void {
  }
}
